import { getAccessToken } from './auth';

interface MeEnvelope {
  result: string;
  reason?: string;
  item?: { url?: string; embed_url?: string };
}

export interface PeppiPrinterUrls {
  /** Vollseite im Solo, zum Öffnen in einem neuen Fenster. */
  url: string;
  /** Einzeiler ohne Chrome, zum Einbetten per iFrame. */
  embedUrl: string;
}

/**
 * Holt vom R2-Backend die token-authentifizierten Solo-URLs, unter denen der
 * aktuelle Benutzer seine Standard-Druckstation (Peppi) verwalten kann.
 */
export async function getPeppiPrinterUrls(): Promise<PeppiPrinterUrls> {
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Nicht angemeldet.');
  }
  const resp = await fetch(`${window.location.origin}/api/me/peppi-printer-url`, {
    headers: {
      'Accept':        'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  let body: MeEnvelope;
  try {
    body = (await resp.json()) as MeEnvelope;
  } catch {
    throw new Error(`Unlesbare Server-Antwort (${resp.status})`);
  }

  if (!resp.ok || body.result !== 'SUCCESS' || !body.item?.url || !body.item?.embed_url) {
    throw new Error(body.reason ?? `Server-Fehler ${resp.status}`);
  }
  return { url: body.item.url, embedUrl: body.item.embed_url };
}

/** Nur die Vollseiten-URL (Aufruf „Zu Drucker" aus dem Druck-Modal). */
export async function getPeppiPrinterUrl(): Promise<string> {
  return (await getPeppiPrinterUrls()).url;
}
